import type React from 'react';

/**
 * Escape inside an add-contact step goes back one step instead of reaching
 * the project drawer, which would close on it.
 */
export const stopEscape =
  (onEscape: () => void) =>
  (event: React.KeyboardEvent): void => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    event.stopPropagation();
    onEscape();
  };
